import { render } from "./SimpleTab.vue?vue&type=template&id=551364b5"
import script from "./SimpleTab.vue?vue&type=script&lang=js"
export * from "./SimpleTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__